import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FILE_UPLOADER} from '../../../../../componentes/file-uploader/file-uploader.component';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-dados-cadastrais',
  templateUrl: './dados-cadastrais.component.html',
  styleUrls: ['./dados-cadastrais.component.css']
})
export class DadosCadastraisComponent implements OnInit {

  @ViewChild(FILE_UPLOADER, {static: false}) fileUploader: any;
  @Input() formGroup!: FormGroup;
  @Input() formSubmitted = false;
  @Input() readonly!: boolean;
  @Input() arquivosSalvos!: any[];

  estados = [
    { value: 'AC', nome: 'Acre' },
    { value: 'AL', nome: 'Alagoas' },
    { value: 'AP', nome: 'Amapá' },
    { value: 'AM', nome: 'Amazonas' },
    { value: 'BA', nome: 'Bahia' },
    { value: 'CE', nome: 'Ceará' },
    { value: 'DF', nome: 'Distrito Federal' },
    { value: 'ES', nome: 'Espírito Santo' },
    { value: 'GO', nome: 'Goiás' },
    { value: 'MA', nome: 'Maranhão' },
    { value: 'MT', nome: 'Mato Grosso' },
    { value: 'MS', nome: 'Mato Grosso do Sul' },
    { value: 'MG', nome: 'Minas Gerais' },
    { value: 'PA', nome: 'Pará' },
    { value: 'PB', nome: 'Paraíba' },
    { value: 'PR', nome: 'Paraná' },
    { value: 'PE', nome: 'Pernambuco' },
    { value: 'PI', nome: 'Piauí' },
    { value: 'RJ', nome: 'Rio de Janeiro' },
    { value: 'RN', nome: 'Rio Grande do Norte' },
    { value: 'RS', nome: 'Rio Grande do Sul' },
    { value: 'RO', nome: 'Rondônia' },
    { value: 'RR', nome: 'Roraima' },
    { value: 'SC', nome: 'Santa Catarina' },
    { value: 'SP', nome: 'São Paulo' },
    { value: 'SE', nome: 'Sergipe' },
    { value: 'TO', nome: 'Tocantins' }
  ];



  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
  }

  get arquivoControl(): FormArray {
    return this.formGroup.get('arquivo') as FormArray; // Método para acessar o FormArray
  }

  onArquivosChange(arquivos: any[]) {
    this.arquivoControl.clear();
    if (arquivos && arquivos.length) {
      arquivos.forEach(arq => {
        this.arquivoControl.push(this.fb.group({
          nomeArquivo: arq.nomeArquivo,
          conteudo: arq.conteudo
        }));
      });
    }
    this.arquivoControl.markAsTouched();
    this.arquivoControl.updateValueAndValidity();
  }
}
